import { useMutation } from "react-query";
import {
  getSignStatus,
  updateEnvelopeStatus,
  resendFailedEnvelopes,
} from "../api/envelope";

const useGetSignStatus = (options = {}) => useMutation(getSignStatus, options);

const useUpdateEnvelopeStatus = (options = {}) =>
  useMutation(updateEnvelopeStatus, options);

const useResendFailedEnvelopes = (options = {}) =>
  useMutation(resendFailedEnvelopes, options);

export { useGetSignStatus, useUpdateEnvelopeStatus, useResendFailedEnvelopes };
